import React, { useState } from 'react';
import { Radio, Spacer } from '@cleartrip/bento';
import classNames from 'classnames';
import { align, inFlyinPage } from "helper/flyin";

function SideBarRadio(props) {
	const { children, active, ...otherProps } = props;
	const wrapperClass = classNames('flex flex-middle px-2 c-pointer nmx-3 br-4', {
		'bg-secondary-500': active,
		'hover:bg-neutral-0': !active,
	});

	function getRadioWrapperClassName(){
		if(inFlyinPage()&&align()=="rtl")
		return 'h-20 my-1'

		return 'h-8'
	}

	return (
		<div className={wrapperClass}>
			<Radio
				color={active ? 'light' : 'secondary'}
				checked={active}
				name='sidebar-radio'
				{...otherProps}
				wrapperClassName={getRadioWrapperClassName()}
				size={16}
				// wrapperClassName={wrapperClass}
			>
				<Spacer className='mr-2' />
				<span
					className={classNames('fs-3 fw-500', {
						'c-white': active,
						'c-neutral-700': !active,
					})}
				>
					{children}
				</span>
			</Radio>
		</div>
	);
}

export default SideBarRadio;
